'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
    [
      '\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-color: ',
      ';\n  ',
      ' ',
      ';\n\n  ',
      ';\n'
    ],
    [
      '\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-color: ',
      ';\n  ',
      ' ',
      ';\n\n  ',
      ';\n'
    ]
  ),
  _templateObject2 = _taggedTemplateLiteral(
    [
      '\n    overflow: hidden;\n    transition: ',
      ' background-size;\n    will-change: background-size;\n    background-size: auto 100%;\n    &:hover {\n      background-size: auto ',
      '%;\n    }\n    ',
      ' {\n      transition: none;\n      background-size: cover !important;\n    }\n  '
    ],
    [
      '\n    overflow: hidden;\n    transition: ',
      ' background-size;\n    will-change: background-size;\n    background-size: auto 100%;\n    &:hover {\n      background-size: auto ',
      '%;\n    }\n    ',
      ' {\n      transition: none;\n      background-size: cover !important;\n    }\n  '
    ]
  )

var _Box = require('./Box')

var _Box2 = _interopRequireDefault(_Box)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

var _styledComponents = require('styled-components')

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var src = function src(props) {
  return props.src && { backgroundImage: 'url(' + props.src + ')' }
}

var height = function height(props) {
  return props.height && { height: props.height }
}

var BackgroundImage = _Box2.default.extend(
  _templateObject,
  function(props) {
    return props.theme.colors.smoke
  },
  src,
  height,
  function(props) {
    return (
      props.scale &&
      (0, _styledComponents.css)(
        _templateObject2,
        function(props) {
          return props.theme.transition
        },
        function(props) {
          return props.theme.scaleFactor * 100
        },
        function(props) {
          return props.theme.mediaQueries.reduceMotion
        }
      )
    )
  }
)

BackgroundImage.displayName = 'BackgroundImage'

BackgroundImage.propTypes = {
  /** background-image url */
  src: _propTypes2.default.string.isRequired,
  /** add hover animation */
  scale: _propTypes2.default.bool,
  /** accessible label */
  'aria-label': _propTypes2.default.string.isRequired
}

BackgroundImage.defaultProps = {
  theme: _theme2.default
}

exports.default = BackgroundImage



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/BackgroundImage.js
// module id = 507
// module chunks = 168707334958949